import React from 'react';
import './TakeoffRsvpAnalytics.css';

function outcomeEntries(obj) {
  if (!obj) return [];
  return Object.entries(obj)
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count);
}

export default function TakeoffRsvpAnalytics({ analytics }) {
  if (!analytics) return null;

  const {
    total = 0,
    attending_count: attendingCount = 0,
    not_attending_count: notAttendingCount = 0,
    no_answer_count: noAnswerCount = 0,
    attendance_rate: attendanceRate = 0,
    outcome_breakdown: outcomeBreakdown = {},
  } = analytics;

  const outcomes = outcomeEntries(outcomeBreakdown);

  return (
    <div className="card takeoff-rsvp-analytics">
      <h3>The Takeoff — Sunday, 23 Aug @ 6 PM, Kairos Hall</h3>

      <div className="stats-grid">
        <div className="stat takeoff-headcount" title="Confirmed guests — expect this many to attend">
          <div className="stat-value">{attendingCount}</div>
          <div className="stat-label">Attending (Guest Headcount)</div>
        </div>
        <div className="stat">
          <div className="stat-value">{notAttendingCount}</div>
          <div className="stat-label">Not Attending</div>
        </div>
        <div className="stat">
          <div className="stat-value">{noAnswerCount}</div>
          <div className="stat-label">No Answer / Maybe</div>
        </div>
        <div className="stat">
          <div className="stat-value">{attendanceRate.toFixed(1)}%</div>
          <div className="stat-label">Confirm Rate</div>
        </div>
      </div>

      <div className="takeoff-section">
        <h4>Total Calls: {total}</h4>
      </div>

      <div className="takeoff-section">
        <h4>Call Outcomes</h4>
        <div className="takeoff-outcome-badges">
          {outcomes.length === 0 ? (
            <span style={{ color: '#666', fontSize: '0.85rem' }}>No data yet.</span>
          ) : (
            outcomes.map((entry) => (
              <span key={entry.name} className="badge badge-neutral">
                {entry.name.replace('_', ' ')}: {entry.count}
              </span>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
